import axios from 'axios';
import Cookies from 'js-cookie';
const dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?(?:[+-]\d{2}:\d{2}|Z)?$/i;
const dateISOMilliseconds = /[.,](\d+)/i;
const dateNet = /\/Date\((-?\d+)(?:-\d+)?\)\//i;
function dateFromString(date) {
    if (dateISO.test(date)) {
        const ms = dateISOMilliseconds.exec(date);
        const fixedValue = date.replace(dateISOMilliseconds, '');
        const result = new Date(fixedValue);
        if (ms !== null) {
            let millisecond = parseInt(ms[1].substr(0, 3), 10);
            millisecond = isNaN(millisecond) ? 0 : millisecond;
            result.setMilliseconds(millisecond);
        }
        return result;
    }
    const parsedDate = dateNet.exec(date);
    if (parsedDate !== null) {
        return new Date(parseInt(parsedDate[1], 10));
    }
    return date;
}
export const initAjaxHandlersCommon = () => {
    const transformer = data => {
        if (typeof data === 'string') {
            return dateFromString(data);
        }
        if (typeof data === 'object') {
            if (data instanceof Blob) {
                return data;
            }
            try {
                // parsing each values one by one to see if it is a date
                return JSON.parse(JSON.stringify(data), (_0, value) => {
                    if (typeof value === 'string') {
                        return dateFromString(value);
                    }
                    return value;
                });
            }
            catch (_a) {
                return data;
            }
        }
        return data;
    };
    if (axios.defaults.transformResponse === undefined) {
        axios.defaults.transformResponse = [transformer];
    }
    else if (Array.isArray(axios.defaults.transformResponse)) {
        axios.defaults.transformResponse.push(transformer);
    }
    else {
        axios.defaults.transformResponse = [axios.defaults.transformResponse, transformer];
    }
    axios.interceptors.request.use(config => {
        setHeaders(config);
        return config;
    });
    axios.defaults.validateStatus = status => status >= 200 && status < 400;
};
const CSRFTokenName = 'X-CSRF-Token';
function setHeaders(config) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h, _j, _k;
    if (!isFormData(config)) {
        (_a = config.headers) !== null && _a !== void 0 ? _a : (config.headers = {});
        (_b = (_g = config.headers)['Content-Type']) !== null && _b !== void 0 ? _b : (_g['Content-Type'] = 'application/json;charset=UTF-8');
        (_c = (_h = config.headers).Accept) !== null && _c !== void 0 ? _c : (_h.Accept = 'application/json');
    }
    if (isRelativeUrl(config)) {
        (_d = config.headers) !== null && _d !== void 0 ? _d : (config.headers = {});
        (_e = (_j = config.headers)['X-Requested-With']) !== null && _e !== void 0 ? _e : (_j['X-Requested-With'] = 'XMLHttpRequest');
        const token = Cookies.get(CSRFTokenName);
        if (token) {
            (_f = (_k = config.headers)[CSRFTokenName]) !== null && _f !== void 0 ? _f : (_k[CSRFTokenName] = token);
        }
    }
}
function isFormData({ data }) {
    return data instanceof FormData;
}
const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i;
function isRelativeUrl({ url }) {
    return url && !absoluteUrlRegex.test(url);
}
//# sourceMappingURL=ajax-handlers-common.js.map